<template>
  <!-- Fields dinamycs;  note: will be can abstract to component for N times and use en another component form -->
  <div
    :style="
      `
  padding-left: ${lv * 5}px;
  padding-bottom: 10px`
    "
  >
    <div
      v-for="(field, index) in campos"
      :key="index"
      :class="field.tipo === 'field_set' ? 'node' : ''"
    >
      <label>{{ field.required ? "* " : "" }}{{ field.etiqueta }}:</label>
      <CInput
        v-if="
          field.tipo !== 'select' &&
            field.tipo !== 'field_set' &&
            field.tipo !== 'text_area' &&
            field.tipo !== 'check'
        "
        v-model="value[field.nombre]"
        :type="field.tipo"
        :placeholder="field.etiqueta"
      />
      <ExtraConfigNodo
        v-if="field.tipo === 'field_set'"
        :campos="field.campos"
        v-model="value"
        :lv="lv + 1"
      />
      <select
        v-if="field.tipo === 'select'"
        class="form-control"
        v-model="value[field.nombre]"
      >
        <option
          v-for="(option, index) in field.config"
          :key="index"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
      <CTextarea
        v-if="field.tipo === 'text_area'"
        v-model="value[field.nombre]"
        :placeholder="field.etiqueta"
      />
      <div v-if="field.tipo === 'check'">
        <input
          type="checkbox"
          class="mycheck2"
          id="mycheck"
          v-model="value[field.nombre]"
        />
      </div>
    </div>
  </div>
  <!-- End fields dinamycs -->
</template>

<script>
import ExtraConfigNodo from "./ExtraConfigNodo";
export default {
  name: "ExtraConfigNodo",
  components: {
    ExtraConfigNodo
  },
  props: {
    lv: {
      type: Number,
      default: 0
    },
    campos: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.$emit("input", newValue);
      },
      deep: true
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.node {
  border: 2px dashed #ccc;
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 10px;
  position: relative;
  & > label {
    top: -12px;
    position: absolute;
    background: #fff;
  }
}
</style>
<style lang="scss" scoped>
.mycheck2 {
  cursor: pointer;
  background-color: #fff;
  color: #fff;
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
  width: 24px;
  height: 24px;
  appearance: none;
  border: 2px solid #321fdb;
  border-radius: 4px;
  background-position: 0 -2rem;
  background-size: 100%;
  background-repeat: no-repeat;
  transition: all 0.3s ease-in-out;
}

.mycheck2:checked {
  background-color: #321fdb;
  color: #321fdb;
  background-position: 0 0;
}
</style>
